import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import { WebPage } from '@grandvision/analytics'
import { DefaultPageProps, DynamicRoutes } from '@grandvision/bloomreach'
import { Cart, Utils as CartUtils } from '@grandvision/carts'
import { LoaderScreen, SupportFooter } from '@grandvision/common'
import { ReduxPersistGate } from '@grandvision/state'

import componentDefinitions from '../cms/component-definitions'
import Layout from '../components/Layout'

const { publicRuntimeConfig } = getConfig()
const staticsUrl = publicRuntimeConfig.grandvision.staticsUrl
const selfUrl = publicRuntimeConfig.selfUrl || ''

function goToCheckout() {
  window.location.assign('/checkout/leverans')
}

function goToPreviousPage() {
  window.history.back()
}

const getCartItemImageUrl = (item) => CartUtils.getItemImageUrl(staticsUrl, item)

const CartPage = ({
  pageModel,
  asPath,
  preview,
  request,
  productRoutes,
  labels = {},
  store,
}: DefaultPageProps) => {
  if (!pageModel) {
    console.error(`No pageModel found for path: ${asPath}!`)
  }

  const pageLabels = {
    cart: labels.cart || {},
    products: labels.products || {},
    support: labels.support || {},
  }

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={pageModel}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => (
        <Layout
          pageModel={pageModel}
          asPath={asPath}
          isSolaris={true}
          preview={preview}
          renderSiteNav={false}
        >
          <RenderCmsComponent path="main/top-container" />
          <ReduxPersistGate loading={<LoaderScreen />} persistor={store!.persistor as any}>
            <DynamicRoutes pageModel={pageModel}>
              {(routeFormatters) => (
                <div className="site-container cart-layout">
                  <Cart
                    readOnly={false}
                    productRoutes={productRoutes as []}
                    getItemImageUrl={getCartItemImageUrl}
                    onPrimaryClick={goToCheckout}
                    onSecondaryClick={goToPreviousPage}
                    {...routeFormatters}
                    isDiscountCodeEnabled={true}
                    showCartDiscountOnLineItem={true}
                    showShippingMethod={true}
                    showTotalDiscount={true}
                    showCartDiscountDescriptions={true}
                  />
                  <SupportFooter
                    message={pageLabels.support.title}
                    phoneNumber={pageLabels.support.phoneNumber}
                    email={pageLabels.support.emailAddress}
                  />
                </div>
              )}
            </DynamicRoutes>
          </ReduxPersistGate>

          <RenderCmsComponent path="main/bottom-container" />

          <WebPage url={selfUrl + asPath} pageType={'PurchaseFunnel'} />
        </Layout>
      )}
    </CmsPage>
  )
}

CartPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, preview, productRoutes, locale } = query as any

  return {
    asPath,
    pageModel,
    preview,
    request,
    productRoutes,
    locale,
  }
}

export default CartPage
